/* ==========================================================================
   oddit-section-faq
   Accordion toggle interaction
   ========================================================================== */

(function () {
  var SECTION_SELECTOR = '.oddit-section-faq';

  function initSection(section) {
    section.addEventListener('click', handleClick);
  }

  function handleClick(e) {
    var trigger = e.target.closest('[data-faq-trigger]');
    if (!trigger) return;

    var item = trigger.closest('[data-faq-item]');
    if (!item) return;

    var answer = item.querySelector('[data-faq-answer]');
    if (!answer) return;

    var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
    var icon = trigger.querySelector('.oddit-section-faq__icon');

    if (isExpanded) {
      trigger.setAttribute('aria-expanded', 'false');
      answer.setAttribute('aria-hidden', 'true');
      answer.hidden = true;
      if (icon) {
        icon.classList.remove('oddit-section-faq__icon--active');
      }
    } else {
      trigger.setAttribute('aria-expanded', 'true');
      answer.setAttribute('aria-hidden', 'false');
      answer.hidden = false;
      if (icon) {
        icon.classList.add('oddit-section-faq__icon--active');
      }
    }
  }

  function destroySection(section) {
    section.removeEventListener('click', handleClick);
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();